document.addEventListener('DOMContentLoaded', updateOverlays);
document.addEventListener('shopify:section:load', updateOverlays);

function updateOverlays() {
  document.querySelectorAll('.product-overlay-logo').forEach(el => {
    const productId = el.dataset.productId;
    if (!productId) return;

    const card = el.closest('[data-product-id]');
    if (!card) return;

    if (card.dataset.productId !== productId) {
      el.setAttribute('hidden', '');
    } else {
      el.removeAttribute('hidden');
    }
  });
}
